import { ABMGenerico } from "src/general_components/ABMGenerico";
import { MenuFuncionalidades } from "./MenuFuncionalidades";
import IconButton from '@mui/material/IconButton'; // Botón para íconos con funcionalidad de clic
import Tooltip from '@mui/material/Tooltip'; // Para mostrar el tooltip sobre el ícono
import { Grid } from "@mui/material";
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import { useState } from "react";
import { SimpleDialogComponent } from "src/general_components/SimpleDialogComponent";

export const Menu = () => {
    // 🌟 Define el modelo que será gestionado en este componente
    const modelo = "menu";

    // 🌟 Estados locales para manejar el estado del modal y el ID del menú seleccionado
    const [modalState, setModalState] = useState(false);
    const [id_menu, setIdMenu] = useState(false);

    // 🌟 Contenido dinámico del modal, que renderiza el componente MenuFuncionalidades
    let dialogChild = <MenuFuncionalidades id_menu={id_menu}></MenuFuncionalidades>;

    /**********************************************************************
        🌟 Define una columna adicional para la tabla de datos con el campo 
        "columna_extra_1", que muestra un ícono para administrar funcionalidades. 
        Al hacer clic en el ícono, se ejecuta `handleButtonClick` con la fila 
        seleccionada como parámetro.
    **********************************************************************/
    const columnasAdicional = [{
        field: "columna_extra_1",
        headerName: "Funcionalidades",
        flex: 1,
        headerAlign: "center",
        renderCell: (params) => (
            <Grid style={{ alignItems: 'center', textAlign: 'center', margin: 'auto' }}>
                <Tooltip title="Administrar Funcionalidades">
                    <IconButton onClick={() => handleButtonClick(params.row)}>
                        <PlaylistAddIcon />
                    </IconButton>
                </Tooltip>
            </Grid>
        )
    }];

    /**********************************************************************
        🌟 Maneja el evento al hacer clic en el botón de funcionalidades. 
        - rowData: Información de la fila seleccionada en la tabla.
        Establece el ID del menú seleccionado y abre el modal.
    **********************************************************************/
    const handleButtonClick = async (rowData) => {
        setIdMenu(rowData.id);
        toggleModal();
    };

    /**********************************************************************
        🌟 Alterna el estado del modal entre abierto y cerrado.
    **********************************************************************/
    const toggleModal = () => {
        setModalState(!modalState);
    };

    return (
        <>
            {/**********************************************************************
                🌟 Renderiza el componente genérico ABMGenerico para gestionar el menú.
                - modelo: Identifica el modelo gestionado ("menu").
                - titulo: Título de la sección.
                - columnasAdicional: Columnas adicionales específicas de este modelo.
            **********************************************************************/}
            <ABMGenerico modelo={modelo} titulo={"Menu"} columnasAdicional={columnasAdicional} />

            {/**********************************************************************
                🌟 Renderiza el componente SimpleDialogComponent como un modal 
                reutilizable para mostrar información detallada o gestionar 
                funcionalidades del menú seleccionado.
                - open: Estado del modal (abierto/cerrado).
                - modalName: Nombre del modal ("Administrador de Funcionalidades").
                - child: Componente hijo dinámico, definido por `dialogChild`.
                - handleClose: Función para cerrar el modal.
                - buttonEnviar y buttonCancelar: Deshabilitados en este caso.
                - maxWidth: Define el ancho máximo del modal.
            **********************************************************************/}
            <SimpleDialogComponent
                open={modalState}
                modalName={"Administrador de Funcionalidades"}
                child={dialogChild}
                handleClose={toggleModal}
                buttonEnviar={false}
                buttonCancelar={false}
                maxWidth="lg"
            />
        </>
    );
};
